import { BaseContextType } from '@smx-ui-model/types';

import { SharingDocumentModelSchemaType } from './types';

export const sharingDocumentCoreModel: SharingDocumentModelSchemaType<BaseContextType> = {
    label: 'Sharing Document',
    name: 'sharingDocument',
    context: {
        inspectorInput: [],
    },
    schema: {} as any,
};
